module.exports = __webpack_public_path__ + "static/10-733d518e80f913ded41966edb7b3d399.jpeg";